import { defineNuxtPlugin, useRouter } from '#imports'

export interface GatesPlugin {
  get(gate: string): boolean
  all(gates: string[]): boolean
  any(gates: string[]): boolean
  route(path: string): string[] | null | false
  access(path: string): boolean
  readonly list: string[] | null
}

export default defineNuxtPlugin((nuxtApp) => {
  const router = useRouter()
  const isExternalPath = (path: string) => /^(?:[a-z][a-z0-9+.-]*:)?\/\//i.test(path) || path.startsWith('mailto:') || path.startsWith('tel:')

  const plugin: GatesPlugin = {
    get(gate) {
      const active = nuxtApp.$auth.active
      const gates = this.list

      if (!active || !gates) {
        return false
      }

      return gates.includes(gate)
    },

    all(gates) {
      return gates
        .every((gate) => {
          return this.get(gate)
        })
    },

    any(gates) {
      return gates
        .some((gate) => {
          return this.get(gate)
        })
    },

    route(path) {
      if (!path) {
        return false
      }
      if (isExternalPath(path)) {
        return null
      }

      const resolved = router.resolve(path)
      const gates = resolved.meta.gates ?? null

      return gates
    },

    access(path) {
      if (!path) {
        return false
      }
      if (isExternalPath(path)) {
        return true
      }

      const resolved = router.resolve(path)
      const gates = resolved.meta.gates ?? null

      if (!gates) {
        return true
      }

      return this.all(gates)
    },

    get list() {
      return nuxtApp.$auth?.info?.gates
    },
  }

  nuxtApp.provide('gates', plugin)
})
